
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaybackInfoItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybackInfoItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"playbackInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlaybackInfoFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":150}};
    doc.loc.source = {"body":"#import \"./playback-info.gql\"\n\nfragment PlaybackInfoItemFields on PlaybackInfoItem {\n  contentItemId\n  playbackInfo {\n    ...PlaybackInfoFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./playback-info.gql").definitions));


      module.exports = doc;
    
